/**
 * @file   src\components\Payments\AddPaymentModalStripe.js
 * @brief  This file is responsible for add payment method
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState } from "react";
import PaymentComponent from "./v2/PaymentComponent";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Modal from "react-bootstrap/Modal";

const AddPaymentModalStripe = (props) => {
  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`)
  );
  return (
    <Modal
      show
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-settings modal-payment plan-payment"
    >
      <Modal.Body className="pt-32 pb-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={props.onHide}
        ></button>
        <Elements stripe={stripePromise}>
          <PaymentComponent {...props} />
        </Elements>
      </Modal.Body>
    </Modal>
  );
};
export default AddPaymentModalStripe;
